import { render, staticRenderFns } from "./HospitalHealthColumn.vue?vue&type=template&id=310df7d8"
import script from "./HospitalHealthColumn.vue?vue&type=script&lang=js"
export * from "./HospitalHealthColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports